import type { RefObject } from 'react';
import { useNavigate } from 'react-router-dom';
import Dialog from './Dialog';
import { Text } from '../general/Text';
import { en } from '../../locales/en';
import { useSelectedGcsConfigsStore } from '../../store/useSelectedGcsConfigsStore';
import { getServerNameCode } from '../../config/gcs/gcsConfigs';
import { useFocusMap } from '../../hooks/useFocusMap';
import type { MapRef } from 'react-map-gl/mapbox';

interface ConfirmRemoveCenterDialogProps {
  gcsId: string;
  onClose: () => void;
  mapRef: RefObject<MapRef | null>;
}

function ConfirmRemoveCenterDialog({ gcsId, onClose, mapRef }: ConfirmRemoveCenterDialogProps) {
  const removeGcsConfig = useSelectedGcsConfigsStore((state) => state.removeGcsConfig);
  const navigate = useNavigate();
  const focusMap = useFocusMap(mapRef);
  const nameCode = getServerNameCode(gcsId);

  const onRemoveClicked = () => {
    removeGcsConfig(gcsId);
    onClose();
    if (useSelectedGcsConfigsStore.getState().selectedConfigs.length == 0) {
      navigate('/sign-in', { replace: true });
      return;
    }
    requestAnimationFrame(() => {
      focusMap();
    });
  };

  return (
    <Dialog
      title={en.confirmRemoveCenterDialog.title}
      onClose={onClose}
      primaryButtonProps={{
        text: en.confirmRemoveCenterDialog.removeCenterButton,
        callback: onRemoveClicked,
        backgroundColor: 'var(--color-danger)',
        foregroundColor: '#ffffff'
      }}
    >
      <div style={{ width: 'var(--dialog-common-width)' }}>
        <Text variant='body1'>{en.confirmRemoveCenterDialog.body.replace('{nameCode}', nameCode)}</Text>
      </div>
    </Dialog>
  );
}

export default ConfirmRemoveCenterDialog;
